module.exports = "/assets/af11f38482645952db27f400267ff56c.svg";